import React, { useEffect, useState } from 'react';
import { Container, Box, Tab, TabList, TabPanel, TabPanels, Tabs, Text } from '@chakra-ui/react';
import { Chart } from '../Chart';

const TabGroup = ({ data }) => {
  const { tabs, title } = data;
  const [selectedTab, setSelectedTab] = useState(0);

  useEffect(() => {
    // Reset the selected tab when the tabs data changes
    setSelectedTab(0);
  }, [tabs]);

  return (
    <Container maxWidth='container.xl' padding='0' px={{ base: 30, xl: 60 }}>
      <Text textStyle='h2' as='h2' mb={2}>
        {title}
      </Text>
      <Tabs index={selectedTab} onChange={(index) => setSelectedTab(index)} isLazy>
        <TabList borderBottom='none'>
          <Box py={{ base: 10, xl: 20 }} pr={10}>
            By:
          </Box>
          {tabs.map((tab, index) => (
            <Tab
              _selected={{ bg: 'grey.light', color: 'black' }}
              _hover={{ bg: 'grey.light' }}
              bg='grey.lightest'
              color='navy'
              textStyle='navItem'
              fontSize='0.875rem'
              letterSpacing='1px'
              key={index}
              padding={{ base: 10, xl: 20 }}
              margin='0 2px'
            >
              {tab.title}
            </Tab>
          ))}
        </TabList>

        <TabPanels>
          {tabs.map(({ _key, chart }) => (
            <TabPanel key={_key} padding='0'>
              <Box>{chart && <Chart data={chart} />}</Box>
            </TabPanel>
          ))}
        </TabPanels>
      </Tabs>
    </Container>
  );
};

export default TabGroup;
